// ============================================================
// VIDEOS POR OFERTA
// ------------------------------------------------------------
// Pega aqui el ID de YouTube de TU video (el de Blinkblis, no el
// de la marca). El ID es lo que va despues de v= en la URL:
//   https://www.youtube.com/watch?v=dQw4w9WgXcQ  ->  'dQw4w9WgXcQ'
//
// Si lo dejas vacio, la seccion de video NO se muestra. La pagina
// se ve completa igual: mejor sin video que con un hueco vacio.
//
// Importante: no incrustes el video oficial de la marca como si
// fuera contenido propio. Graba uno de Blinkblis.
// ============================================================

export const OFFER_VIDEOS: Record<string, string> = {
  credito: '',
}

export const videoFor = (slug: string) => OFFER_VIDEOS[slug] || ''
